export default {"src":"/_next/static/media/pa.5b4056b3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};